var PAGE_CONTAINER_ELEMS = ['div', 'main', 'section'];
var HAS_FIXED_HEADER_VALUES = [true, false, 'no-nav'];

export { HAS_FIXED_HEADER_VALUES, PAGE_CONTAINER_ELEMS };
